import React, { useRef, useState } from "react"
import { useWindowSize } from "@components/helpers/useWindowSize"
import DynamicProductCard from "../../productcards/DynamicProductCard"
import DisplayCard from "../../productcards/DisplayCard"
import LookbookCard from "@components/productcards/LookbookCard"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"

import SliderButton from "../../../image/icons/slider-button.svg"
import CollabCard from "@components/productcards/CollabCard"
import clsx from "clsx"

const ProductSwiper = ({
	products,
	cardType = "product card",
	cardStyles = "",
	cardOptions = "",
	spaceBetween = 0,
	slidesPerView = 4,
	breakpoints = {
		// value of key is min-width property
		300: {
			slidesPerView: 1.5,
			spaceBetween: 5,
		},
		500: {
			slidesPerView: 1,
			spaceBetween: 10,
		},
		640: {
			slidesPerView: 3.5,
		},
		900: {
			slidesPerView: 4,
		},
		1024: {
			slidesPerView: 5,
		},
	},
	navigation = true,
	pagination = false,
	width = null,
	height = null,
	loop = false,
	onClickCard = null,
	ariaLabel = "",
}) => {
	const uws = useWindowSize()
	const [isSwiping, setIsSwiping] = useState(false)
	const [touchStartX, setTouchStartX] = useState(0)
	const [touchStartY, setTouchStartY] = useState(0)

	const handleTouchStart = (e) => {
		setTouchStartX(e.touches[0].clientX)
		setTouchStartY(e.touches[0].clientY)
		setIsSwiping(false)
	}

	const handleTouchMove = (e) => {
		const deltaX = Math.abs(e.touches[0].clientX - touchStartX)
		const deltaY = Math.abs(e.touches[0].clientY - touchStartY)

		// threshold in px to decide if it's a swipe
		if (deltaX > 10 || deltaY > 10) {
			setIsSwiping(true)
		}
	}

	const handleTouchEnd = () => {
		setTouchStartX(0)
		setTouchStartY(0)
	}

	const navigationPrevRef = useRef(null)
	const navigationNextRef = useRef(null)

	if (!uws?.width) return
	return (
		<React.Fragment>
			<div 
				className="max-w-full mx-auto mt-6 md:mt-0"
				onTouchStart={handleTouchStart}
				onTouchMove={handleTouchMove}
				onTouchEnd={handleTouchEnd}
			>
				<Swiper
					aria-label={ariaLabel}
					spaceBetween={spaceBetween}
					slidesPerView={slidesPerView}
					breakpoints={breakpoints}
					modules={[Navigation]}
					loop={loop}
					navigation={
						navigation
							? {
									prevEl: navigationPrevRef.current,
									nextEl: navigationNextRef.current,
							  }
							: false
					}
					onBeforeInit={(swiper) => {
						swiper.params.navigation.prevEl = navigationPrevRef.current
						swiper.params.navigation.nextEl = navigationNextRef.current
					}}
					className="mySwiper"
					onSliderFirstMove={() => setIsSwiping(true)}
					onTouchEnd={() => {
						setTimeout(() => setIsSwiping(false), 100)
					}}
				>
					{products &&
						products.map((product, index) => {
							if (product?.title && !product.title.includes("FREE")) {
								return (
									<SwiperSlide key={`just-in-${product?.id ?? index}`}>
										{cardType === "display card" ? (
											<DisplayCard data={product} cardStyles={cardStyles} />
										) : cardType === "lookbook card" ? (
											<LookbookCard data={product} onClick={onClickCard} isSwiping={isSwiping} />
										) : cardType === "collab card" ? (
											<CollabCard
												data={product}
												className={clsx(cardStyles)}
												showButton
											/>
										) : (
											<DynamicProductCard
												data={product}
												cardOptions={cardOptions}
												style={`${
													cardType === "compact" ? "compact" : "classic"
												}`}
												cardStyles={cardStyles}
												width={width}
												height={height}
												isSwiping={isSwiping}
											/>
										)}
									</SwiperSlide>
								)
							}
							return null
						})}

					<div
						className={clsx('text-black size-4 p-2 rounded cursor-pointer z-30 absolute bottom-[60%]', cardType === "lookbook card" ? "top-[48%]" : "top-[40%]")}
						ref={navigationPrevRef}
					>
						<img
							className="absolute -top-5 w-11 h-11 max-w-11"
							src={SliderButton}
							alt="slide- "
						/>
					</div>

					<div
						className={clsx('text-black size-4 p-2 rounded cursor-pointer z-30 absolute bottom-[60%] right-0', cardType === "lookbook card" ? "top-[48%]" : "top-[40%]")}
						ref={navigationNextRef}
					>
						<img
							className="absolute -left-10 -top-5 w-11 h-11 max-w-11 transform rotate-180"
							src={SliderButton}
							alt="slide-left"
						/>
					</div>
				</Swiper>
			</div>
		</React.Fragment>
	)
}

export default ProductSwiper
